// Приведение номера к нужному формату 8XXXXXXXXXX
export function normalizeOutgoingNumber(num = '') {
  // Убираем все пробелы и лишние символы
  num = num.replace(/\D/g, '');

  // Если начинается на 7 или +7 — заменяем на 8
  if (num.startsWith('7')) return '8' + num.slice(1);
  if (num.startsWith('8')) return num;
  return num;
}
// Формат 7XXXXXXXXXX
export function normalizeNumberForDataBase(num = '') {
  // Убираем все символы кроме цифр
  num = num.replace(/\D/g, '');

  // Если начинается на 8 — заменяем на 7
  if (num.startsWith('8')) return '7' + num.slice(1);
  if (num.startsWith('7')) return num;
  return num;
}
